<template>
  <v-container fluid tag="section">
    <validation-observer ref="observer" slim v-slot="{ invalid }">
      <v-row>
        <v-col cols="12">
          <base-material-card
            color="primary"
            icon="mdi-clipboard-outline"
            title="Consultar Aprovações"
            inline
            class="px-4 py-2 ml-0"
            elevation="0"
          >
            <v-row class="mx-1 mb-5 mt-3">
              <v-col cols="12" md="auto">
                <div
                  class="text-subtitle-1 font-weight-medium mb-2 grey--text body-2"
                >
                  Período de Competência
                </div>
                <div class="d-flex align-center">
                  <input-month
                    v-if="relatorioSelecionado !== 'Técnicos'"
                    rules="min:7"
                    :minMonth="'2023-01'"
                    :selectedMonth="competencia_de"
                    @monthSelected="setCompetenciaDe"
                    outlined
                    dense
                    class="mr-4"
                  />
                  <span
                    v-if="relatorioSelecionado !== 'Técnicos'"
                    class="mx-3 grey--text body-2"
                  >
                    até
                  </span>
                  <input-month
                    rules="min:7"
                    :minMonth="'2023-01'"
                    :selectedMonth="competencia_ate"
                    @monthSelected="setCompetenciaAte"
                    outlined
                    dense
                  />
                </div>
              </v-col>
              <v-col v-if="companies.length > 1" cols="auto">
                <div
                  class="text-subtitle-1 font-weight-medium mb-2 grey--text body-2"
                >
                  Empresas
                </div>

                <v-select
                  v-model="selectedCompanies"
                  :items="companies"
                  clearable
                  outlined
                  class="pt-0"
                  item-text="name"
                  item-value="id"
                  multiple
                  dense
                  :error-messages="
                    selectedCompanies.length < 1
                      ? 'Selecione pelo menos uma empresa'
                      : ''
                  "
                  @blur="
                    selectedCompaniesIsDirty ? consultarAprovacoes() : null
                  "
                >
                  <template v-slot:prepend-item>
                    <v-list-item
                      ripple
                      @mousedown.prevent
                      @click="selectAllCompanies()"
                    >
                      <v-list-item-action>
                        <v-icon
                          :color="
                            selectedCompanies.length === companies.length
                              ? 'indigo darken-4'
                              : ''
                          "
                        >
                          {{
                            selectedCompanies.length === companies.length
                              ? "mdi-checkbox-marked"
                              : "mdi-checkbox-blank-outline"
                          }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          Selecionar todas
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                  <template v-slot:selection="{ item, index }">
                    <v-chip small>
                      {{ item.sigla_oficial }}
                    </v-chip>
                  </template>
                </v-select>
              </v-col>

              <v-row justify="end" class="pt-5">
                <v-col cols="auto">
                  <v-btn
                    id="btn-consulta-detalhada"
                    color="primary"
                    dark
                    relative
                    medium
                    outlined
                    style="float: right"
                    :disabled="invalid"
                    :loading="downloadingConsulta"
                    @click="baixarConsultaDetalhada()"
                  >
                    <v-icon left size="30px">
                      mdi-microsoft-excel
                    </v-icon>
                    Consulta Detalhada
                  </v-btn>
                </v-col>
              </v-row>
            </v-row>
          </base-material-card>
        </v-col>
      </v-row>

      <v-row justify="center" class="mt-n4">
        <v-col cols="12">
          <v-expansion-panels v-model="panels" accordion multiple flat>
            <v-expansion-panel
              v-for="base in bases"
              :key="base.value"
              class="mb-4"
            >
              <v-expansion-panel-header>
                <strong>{{ base.text }}</strong>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-data-table
                  class="data-table"
                  multi-sort
                  dense
                  :headers="headers"
                  :items="items[base.value]"
                  :options="{ itemsPerPage: -1 }"
                  :headerProps="{ sortByText: 'Ordenar Por' }"
                  no-data-text="Nenhum registro disponível"
                  no-results-text="Nenhum registro correspondente encontrado"
                  :mobile-breakpoint="10"
                >
                  <template v-slot:[`item.perc_aprovados`]="{ item }">
                    <span
                      :class="
                        item.perc_aprovados === 0
                          ? 'black--text font-weight-bold'
                          : 'success--text font-weight-bold'
                      "
                    >
                      {{
                        item.perc_aprovados | parseNumberToFloatBrIgnoringNaN
                      }}
                      %
                    </span>
                  </template>
                  <template v-slot:[`item.perc_reprovados`]="{ item }">
                    <span
                      :class="
                        item.perc_reprovados === 0
                          ? 'black--text font-weight-bold'
                          : 'warning--text font-weight-bold'
                      "
                    >
                      {{
                        item.perc_reprovados | parseNumberToFloatBrIgnoringNaN
                      }}
                      %
                    </span>
                  </template>
                  <template v-slot:[`item.perc_nao_validados`]="{ item }">
                    <span
                      :class="
                        item.perc_nao_validados === 0
                          ? 'black--text font-weight-bold'
                          : 'accent--text font-weight-bold'
                      "
                    >
                      {{
                        item.perc_nao_validados
                          | parseNumberToFloatBrIgnoringNaN
                      }}
                      %
                    </span>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </validation-observer>
    <v-overlay :value="loading" :opacity="0.85">
      <v-progress-circular indeterminate color="primary" size="64" />
    </v-overlay>
  </v-container>
</template>

<script>
  import ConsultaAprovacoesTemasService from "@/services/ConsultaAprovacoesTemasService.js";
  import CompanyService from "@/services/CompanyService.js";
  import { mapState, mapActions } from "vuex";

  export default {
    name: "ConsultaAprovacoesTemasIndex",
    components: {
      InputMonth: () => import("@/components/general/InputMonth.vue"),
    },
    data: () => ({
      loading: false,
      downloadingConsulta: false,
      panels: [0, 1, 2],
      bases: [
        { text: "COMERCIAL", value: "comercial" },
        { text: "SERVIÇOS", value: "servicos" },
        { text: "TÉCNICOS", value: "tecnicos" },
      ],
      companies: [],
      selectedCompanies: [],
      selectedCompaniesIsDirty: false,
      headers: [
        {
          text: "Distribuidora",
          value: "sigla",
        },
        {
          text: "Competência",
          value: "competencia",
        },
        {
          text: "Tema",
          value: "tema",
        },
        {
          text: "Aprovados",
          value: "perc_aprovados",
        },
        {
          text: "Reprovados",
          value: "perc_reprovados",
        },
        {
          text: "Não Validados",
          value: "perc_nao_validados",
        },
      ],
      items: {},
    }),
    computed: {
      ...mapState("parametrosConsultaAprovacoesTemas", [
        "competencia_de",
        "competencia_ate",
      ]),
    },
    async created() {
      this.setRangeCompetencias();

      this.selectedCompanies.push(this.$store.getters.getCompanyId);
      await this.getCompanies();

      this.consultarAprovacoes();
    },
    methods: {
      ...mapActions("parametrosConsultaAprovacoesTemas", [
        "setRangeCompetencias",
        "setCompetenciaDe",
        "setCompetenciaAte",
      ]),
      getCompanies() {
        this.loadingTable = true;

        return CompanyService.getCompanies()
          .then((res) => {
            this.companies = res;
          })
          .catch((err) => {
            throw err;
          });
      },
      selectAllCompanies() {
        this.$nextTick(() => {
          if (this.selectedCompanies.length === this.companies.length) {
            this.selectedCompanies = [];
          } else {
            this.selectedCompanies = this.companies.map(
              (company) => company.id
            );
          }
        });
      },
      consultarAprovacoes() {
        this.loading = true;
        this.selectedCompaniesIsDirty = false;

        ConsultaAprovacoesTemasService.consultar(
          this.competencia_de,
          this.competencia_ate,
          this.selectedCompanies
        )
          .then((res) => {
            this.items = res;
          })
          .catch((err) => {
            this.$toast.error("Falha ao consultar aprovações.", "", {
              position: "topRight",
              timeout: 5000,
            });
            throw err;
          })
          .finally(() => (this.loading = false));
      },
      baixarConsultaDetalhada() {
        this.downloadingConsulta = true;

        this.$toast.info(
          "Preparando sua consulta para download, essa etapa pode demorar, por favor, aguarde.",
          "",
          {
            position: "topRight",
            timeout: 5000,
          }
        );

        ConsultaAprovacoesTemasService.baixarConsultaDetalhada(
          this.competencia_de,
          this.competencia_ate,
          this.selectedCompanies,
          { timeout: 60 * 60 * 1000 }
        )
          .then(async (res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;

            let nomeArquivo = `Consulta_Aprovacoes_de_Temas-${this.$store.getters.getCompanySigla}-${this.competencia_de}_${this.competencia_ate}`;

            link.setAttribute("download", `${nomeArquivo}.xlsx`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            this.$toast.error("Falha no download do arquivo.", "", {
              position: "topRight",
              timeout: 5000,
            });
            throw err;
          })
          .finally(() => (this.downloadingConsulta = false));
      },
    },
    watch: {
      competencia_de() {
        this.consultarAprovacoes();
      },
      competencia_ate() {
        this.consultarAprovacoes();
      },
      selectedCompanies(newVal, oldVal) {
        if (newVal.join() !== oldVal.join()) {
          this.selectedCompaniesIsDirty = true;
        } else {
          this.selectedCompaniesIsDirty = false;
        }
      },
    },
  };
</script>

<style>
  .data-table {
    margin: 10px 0;
    padding: 10px;
  }
  .data-table table tbody tr td {
    font-size: 12px;
    padding: 0px 8px !important;
    text-align: end;
  }

  .data-table table thead tr th {
    font-size: 12px;
    height: 25px;
    text-align: end !important;
    font-weight: 500;
  }
</style>
